import React, { useEffect } from 'react';
import { GuideAppContainer, RenderOnlyFor, SocialActionBar, useGuideConfig, useNeuroMessages } from '@ignitesales/neuro-application';
import ThemeRunnerTool from "./themeRunnerTool/ThemeRunnerTool";
import SocialActionHeader from "./SocialActionHeader";
import ContactOnExit from "./ContactOnExit";
import ModalProvider from "./ModalProvider";

const DialogueThemeContainer = ({ children, useSocialBar, useSocialHeader, socialHeaderId, socialHeaderThreshold }) => {
    const { isDemoMode } = useGuideConfig();
    const { getMessage } = useNeuroMessages();
    const faviconUrl = getMessage('favicon');

    //TODO: fix this...it is meant to update DOM title (can be better via publishing with 'title.default')
    document.title = getMessage('guide.name');

    useEffect(() => {
      const linkElement = document.querySelector("link[rel='icon']");
      if (linkElement && faviconUrl) {
        linkElement.href = faviconUrl;
      }
    }, [faviconUrl]);


    return (
      <GuideAppContainer className='dialogue-theme' useDevelopmentTool={!isDemoMode}>
        <ModalProvider>
          { children }
          <RenderOnlyFor forSummaryPage={true} forDetailsPage={true}>
              { useSocialBar && <SocialActionBar useStackedLayout={true} /> }
              { useSocialHeader && <SocialActionHeader elementId={socialHeaderId || 'summaryPage'} threshold={socialHeaderThreshold || 10} /> }
          </RenderOnlyFor>
          { !isDemoMode && <ThemeRunnerTool /> }
          <ContactOnExit />
        </ModalProvider>
      </GuideAppContainer>
    );
};

export default DialogueThemeContainer;
